import type { FontAwesomeIcon } from "@/models/api";

// eslint-disable-next-line prettier/prettier
export type IconString = `${FontAwesomeIcon["type"]}.${FontAwesomeIcon["name"]}.${FontAwesomeIcon["style"]}`;

export function iconStringToIconObject(name: IconString): FontAwesomeIcon {
  const [type, title, style] = name.split(".");
  return { type, name: title, style } as FontAwesomeIcon;
}

export function iconObjectToIconString(icon: FontAwesomeIcon): IconString {
  return `${icon.type}.${icon.name}.${icon.style}`;
}
